/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ResetPasswordPage_viewer$ref = any;
export type queries_ResetPasswordPage_QueryVariables = {};
export type queries_ResetPasswordPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": ResetPasswordPage_viewer$ref;
    }) | null;
};
export type queries_ResetPasswordPage_Query = {
    readonly response: queries_ResetPasswordPage_QueryResponse;
    readonly variables: queries_ResetPasswordPage_QueryVariables;
};



/*
query queries_ResetPasswordPage_Query {
  viewer {
    id
    ...ResetPasswordPage_viewer
  }
}

fragment ResetPasswordPage_viewer on Viewer {
  id
  user {
    id
    userId
    firstName
    lastName
    email
    role
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_ResetPasswordPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "ResetPasswordPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_ResetPasswordPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "userId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "queries_ResetPasswordPage_Query",
            "id": null,
            "text": "query queries_ResetPasswordPage_Query {\n  viewer {\n    id\n    ...ResetPasswordPage_viewer\n  }\n}\n\nfragment ResetPasswordPage_viewer on Viewer {\n  id\n  user {\n    id\n    userId\n    firstName\n    lastName\n    email\n    role\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8da80500ef4e46ce1db990ff7e24768e';
export default node;
